var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pathology"},[_c('img',{attrs:{"src":require("@/assets/img/icons.svg") + "#icon-pathology","width":"16","height":"16"}}),_vm._v("\n  Pathologie : "+_vm._s(_vm.pathology)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }